import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { useDispatch, useSelector } from "react-redux";
import {
  Grid,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Box,
  TextField,
  MenuItem,
  Autocomplete,
} from "@mui/material";
import { FadeLoader } from "react-spinners";
import EmployeeProfileVeiwController from "../../redux/actions/EmployeeProfileApiAction";
import AppraisalViewController from "../../redux/actions/AppraisalAction";


// Status options same as model CYCLE_STATUS_CHOICES
const statusOptions = [
  { value: "draft", label: "Draft" },
  { value: "in_review", label: "In Review" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
  { value: "applied", label: "Applied to Payroll" },
];

function AppraisalCycleFormModal({ show, handleClose, initialData = null }) {
  const dispatch = useDispatch();
  const { getEmployees } = EmployeeProfileVeiwController();
  const { addAppraisalCycle, updateAppraisalCycle, getEmployeeForAppraisalCycle} = AppraisalViewController();

 const { all_employee, isLoding } = useSelector((state) => state.apprisalcycle);

  const isEdit = Boolean(initialData?.id);

  const [initialValues, setInitialValues] = useState({
    employee: "",
    cycle_start: "",
    cycle_end: "",
    old_salary: "",
    hike_percentage: "",
    effective_from: "",
    average_rating: "",
    status: "draft",
  });

  useEffect(() => {
    // Fetch employees for dropdown
    dispatch(getEmployeeForAppraisalCycle());

    if (show && initialData) {
      setInitialValues({
        employee: initialData.employee || "",
        cycle_start: initialData.cycle_start || "",
        cycle_end: initialData.cycle_end || "",
        old_salary: initialData.old_salary || "",
        hike_percentage: initialData.hike_percentage || "",
        effective_from: initialData.effective_from || "",
        average_rating: initialData.average_rating || "",
        status: initialData.status || "draft",
      });
    } else if (show && !initialData) {
      setInitialValues({
        employee: "",
        cycle_start: "",
        cycle_end: "",
        old_salary: "",
        hike_percentage: "",
        effective_from: "",
        average_rating: "",
        status: "draft",
      });
    }
  }, [show, initialData, dispatch]);

  const handleSubmit = (values, { resetForm }) => {
    const action = isEdit
      ? updateAppraisalCycle(initialData.id, values)
      : addAppraisalCycle(values);

    dispatch(action)
      .then(() => {
        resetForm();
        handleClose();
      })
      .catch((error) => {
        console.error("Error submitting appraisal form:", error);
      });
  };

  return (
    <Dialog open={show} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>
        {isEdit ? "Edit Appraisal Cycle" : "Add Appraisal Cycle"}
      </DialogTitle>

      <DialogContent dividers style={{ maxHeight: "600px", overflowY: "auto" }}>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ values, setFieldValue, handleChange }) => (
            <Form>
              <Grid container spacing={2}>
                {/* Employee Dropdown */}
                <Grid item xs={12} md={6}>
                 <Autocomplete
  fullWidth
  options={all_employee || []}
  getOptionLabel={(option) =>
    option.full_name || `${option.first_name} ${option.last_name}`
  }
  value={
    all_employee.find((emp) => emp.id === values.employee) || null
  }
  onChange={(e, newValue) => {
    if (newValue) {
      setFieldValue("employee", newValue.id);
      setFieldValue("old_salary", newValue.basic_salary || ""); // ✅ Auto-fill old salary
    } else {
      setFieldValue("employee", "");
      setFieldValue("old_salary", "");
    }
  }}
  renderInput={(params) => (
    <TextField {...params} label="Employee" />
  )}
/>

                </Grid>

                {/* Cycle Start */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    type="date"
                    label="Cycle Start"
                    name="cycle_start"
                    value={values.cycle_start}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>

                {/* Cycle End */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    type="date"
                    label="Cycle End"
                    name="cycle_end"
                    value={values.cycle_end}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>

                {/* Old Salary */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Old Salary"
                    name="old_salary"
                    value={values.old_salary}
                    onChange={handleChange}
                  />
                </Grid>

                {/* Hike Percentage */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Hike Percentage (%)"
                    name="hike_percentage"
                    value={values.hike_percentage}
                    onChange={handleChange}
                  />
                </Grid>

                {/* Effective From */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    type="date"
                    label="Effective From"
                    name="effective_from"
                    value={values.effective_from}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>

                {/* Average Rating */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    type="number"
                    step="0.01"
                    label="Average Rating"
                    name="average_rating"
                    value={values.average_rating}
                    onChange={handleChange}
                  />
                </Grid>

                {/* Status */}
                <Grid item xs={12} md={6}>
                  <TextField
                    select
                    fullWidth
                    label="Status"
                    name="status"
                    value={values.status}
                    onChange={handleChange}
                  >
                    {statusOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                {/* Buttons */}
                <Grid item xs={12} textAlign="right">
                  <Button
                    variant="outlined"
                    onClick={handleClose}
                    sx={{ mr: 2 }}
                  >
                    Cancel
                  </Button>
                  <Button type="submit" variant="contained" color="primary">
                    {isEdit ? "Update" : "Submit"}
                  </Button>
                </Grid>
              </Grid>

              {isLoding && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    height: "100vh",
                    width: "100vw",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "rgba(255, 255, 255, 0.6)",
                    zIndex: 9999,
                  }}
                >
                  <FadeLoader loading={true} size={150} />
                </div>
              )}
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
}

export default AppraisalCycleFormModal;
